<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepFinished.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepFinished.BODY')"></p>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click.native="$emit('finish')">{{ $t('tutorial.buttons.FINISH') }}</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'tutorial-step2'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStepFinished.vue